import React from 'react';
import { Navigate } from 'react-router-dom';
import { canAccessMenu } from '../../utils/permissions';
import { useCurrentMenuKey } from '../../hooks/useMenuCatalog';

/**
 * Soft route guard: redirect to dashboard if user lacks menu access
 * for the current route (or an explicit menuKey override).
 */
const RequireMenuAccess = ({ menuKey, children }) => {
  const currentMenuKey = useCurrentMenuKey();
  const resolvedKey = menuKey || currentMenuKey;
  if (resolvedKey && !canAccessMenu(resolvedKey)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default RequireMenuAccess;
